const myMixin = {
    data() {
        return {
            timestamp: '',
            numRandom: '',
            mainSign: '',
            thisToken:'WEKJGHDFDFNL'
        }
    },
    created () {
        this.timestamp = (Date.parse(new Date()) / 1000).toString();
    this.numRandom = Math.floor(Math.random() * 999999).toString();
        this.mainSign = this.$md5(this.thisToken + this.numRandom + this.timestamp);
        // console.log(this.mainSign);
        
    }
}
export default myMixin;